import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import axios from "../utils/axiosConfig";
import { useParams } from "react-router-dom";
import {
  Container,
  Box,
  Grid,
  TextField,
  CircularProgress,
  Typography,
  Button,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import BreadcrumbNav from "../components/BreadcrumbNav";
import { textFieldStyles } from "../styles/textFieldStyles";
import SubmitButton from "../components/SubmitButton";
import CancelButton from "../components/CancelButton";
function AlarmSettingsForm() {
  const { t } = useTranslation(['common', 'pages', 'forms', 'buttons']);
  const [signalingHours, setSignalingHours] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const files = useSelector((state) => state.fileList.files || []);
  const [limitOnFees, setLimitOnFees] = useState(null);
  const [warningThreshold, setWarningThreshold] = useState(null);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const [breadcrumbs, setBreadcrumbs] = useState([
    { label: t('common:home'), href: "/" },
    { label: t('common:timesheets'), href: "/timesheets" },
  ]);
  const locationCaseId = location.state?.caseId;
  const initialCaseFile =
    files?.find((file) => file._id === locationCaseId) || null;

  useEffect(() => {
    if (initialCaseFile) {
      setSignalingHours(initialCaseFile?.signalingHours || 0);
      setLimitOnFees(initialCaseFile?.limitOnFees || 0);
      setWarningThreshold(initialCaseFile?.warningThreshold || 0);
      setBreadcrumbs((prevBreadcrumbs) => {
        const exists = prevBreadcrumbs.some(
          (breadcrumb) =>
            breadcrumb.href === `/files/${initialCaseFile._id}/timesheets`
        );
        if (exists) {
          return prevBreadcrumbs;
        }
        return [
          ...prevBreadcrumbs,
          {
            label: initialCaseFile.name || t('common:case_file'),
            href: `/files/${initialCaseFile._id}/timesheets`,
          },
        ];
      });
    }
  }, [initialCaseFile]);

  const handleCancel = () => {
    navigate(`/files/${initialCaseFile._id}/timesheets`);
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);
    await axios.put(`/api/files/${id}/alarmSettings`, {
      signalingHours,
      limitOnFees,
      warningThreshold,
    });
    setTimeout(() => {
      navigate(-1);
    }, 1000);
  };

  return (
    <Container
      maxWidth="lg"
      style={{ position: "relative", paddingBottom: "80px" }}
    >
      <BreadcrumbNav
        title={t('pages:timesheets.create_new')}
        breadcrumbs={breadcrumbs}
        showBreadcrumbs={true}
      />

      <Box
        sx={{
          backgroundColor: "white",
          padding: "30px 24px",
          marginTop: "24px",
        }}
      >
        <Typography
          sx={{
            color: "rgb(35, 35, 35)",
            display: "block",
            fontFamily:
              '"Fira Sans", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif',
            fontSize: "12.5px",
            fontWeight: 600,
            height: "15.75px",
            lineHeight: "15.75px",
            marginBottom: "8px",
          }}
        >
          Budgets
        </Typography>
        <form onSubmit={handleSave}>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <TextField
                label={t('forms:signaling_hours')}
                type="number"
                step="0.10"
                value={signalingHours}
                onChange={(e) => setSignalingHours(e.target.value)}
                fullWidth
                sx={textFieldStyles()}
                size="small"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                label={t('forms:limit_on_fees')}
                type="number"
                value={limitOnFees}
                onChange={(e) => setLimitOnFees(e.target.value)}
                fullWidth
                sx={textFieldStyles()}
                size="small"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                label={t('forms:warning_threshold')}
                type="number"
                value={warningThreshold}
                onChange={(e) => setWarningThreshold(e.target.value)}
                fullWidth
                sx={textFieldStyles()}
                size="small"
              />
            </Grid>
          </Grid>
          <Box
            mt={4}
            sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}
          >
            <CancelButton
              variant="outlined"
              onClick={handleCancel}
              size="small"
            >
              {t('buttons:cancel')}
            </CancelButton>
            <SubmitButton onClick={handleSave} size="small">
            {loading ? (
                <CircularProgress size={24} sx={{ color: "white" }} />
              ) : (
                "                t('buttons:save')"
              )}
            </SubmitButton>
          </Box>
        </form>
      </Box>
    </Container>
  );
}

export default AlarmSettingsForm;
